import { useEffect } from "react";
import cn from "classnames";
import styles from "./GlobalNotifs.module.scss";
import { useGlobalNotifsControl } from "./useGlobalNotifsControl";
import Loader from "@components/global/Loader/Loader";

export default function GlobalNotifs() {
  const control = useGlobalNotifsControl();
  useEffect(() => {
    const hide = setTimeout(
      () => control.ref.current?.classList.remove(styles.active),
      control.timer
    );
    return () => clearTimeout(hide);
  }, [control.text]);

  const errorIcon = (
    <svg
      viewBox="0 0 24 24"
      width="100%"
      height="100%"
      fill="var(--toastify-icon-color-error)"
    >
      <path d="M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"></path>
    </svg>
  );

  const successIcon = (
    <svg
      viewBox="0 0 24 24"
      width="100%"
      height="100%"
      fill="var(--toastify-icon-color-success)"
    >
      <path d="M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"></path>
    </svg>
  );

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.active]: !!control.text || control.loading,
      })}
      ref={control.ref}
    >
      {control.loading && <Loader className={styles.loader} size={20} />}
      {!control.loading && control.icon
        ? control.isError
          ? errorIcon
          : successIcon
        : null}
      {!!control.text && <p>{control.text}</p>}
    </div>
  );
}
